import React, { FC } from 'react';
import Box from '@material-ui/core/Box';
import {
  makeStyles,
  createStyles,
  Typography,
  Button,
} from '@material-ui/core';
import BottomDrawerLayout, {
  DrawerSnapType,
} from '../../bottom-drawer-layout/BottomDrawerLayout';
import { useTranslation } from '../../../../../hooks/useTranslation';
import colors from '../../../../../themes/main-colors';
import theme from '../../../../../themes/theme';
import GreenCheckIcon from '../../../../../static/greenCheckIcon.svg';

const useStyles = makeStyles(() =>
  createStyles({
    bottomSheet: {
      padding: '20px 20px 0',
      paddingTop: 0,
      textAlign: 'center',
      height: 'auto',
    },
    infoMessageHeader: {
      marginBottom: '1rem',
      marginLeft: '1rem',
    },
    infoMessage: {
      marginBottom: '1rem',
      fontWeight: 'bold',
    },
    checkBreakerCloseButton: {
      padding: theme.spacing(1.625),
      backgroundColor: colors.sparkBlue,
      borderRadius: 5,
      color: colors.white,
      fontSize: '1.125rem',
      marginTop: '2.5rem',
      letterSpacing: 0.36,
      lineHeight: '1.125rem',
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        borderRadius: 50,
      },
    },
  }),
);

type Props = {
  open: boolean;
  onClose: () => void;
};

const ResetBreakerConfirmMob: FC<Props> = ({ onClose }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const customerCarePortland = t('CUSTOMER_CARE_NUMBER_PORTLAND');
  const customerCareNumber = t('CUSTOMER_CARE_NUMBER_OTHER');

  return (
    <BottomDrawerLayout
      onClose={onClose}
      data-testid={'notification-options'}
      refId={0}
      defaultSnap={DrawerSnapType.default}
    >
      <Box component="div" className={classes.bottomSheet}>
        <GreenCheckIcon style={{ width: '100%', marginBottom: '1rem' }} />
        <Typography variant={'h3'} className={classes.infoMessageHeader}>
          {t('THANKYOU_FOR_CHECKING_YOUR_BREAKER')}
        </Typography>
        <Box>
          <Typography variant={'subtitle1'} className={classes.infoMessage}>
            {t('ADDTIONAL_MESSAGING')}
          </Typography>
          <Typography variant={'subtitle1'}>
            {t('ADDITIONAL_MESSAGE_CALLBACK')}{' '}
            {
              <a
                href={'tel:' + customerCarePortland}
                style={{
                  textDecoration: 'underline',
                  color: colors.brightBlue,
                }}
              >
                {' '}
                {customerCarePortland}
              </a>
            }{' '}
            {t('OR')}{' '}
            {
              <a
                href={'tel:' + customerCareNumber}
                style={{
                  textDecoration: 'underline',
                  color: colors.brightBlue,
                }}
              >
                {' '}
                {customerCareNumber}
              </a>
            }{' '}
            {t('TO_SPEAK_WITH_AN_ADVISOR')}
          </Typography>
        </Box>
        <Button
          aria-label="checking-breaker-close"
          className={classes.checkBreakerCloseButton}
          onClick={onClose}
        >
          {t('CLOSE')}
        </Button>
      </Box>
    </BottomDrawerLayout>
  );
};

export default ResetBreakerConfirmMob;
